"use client";

import { useEffect } from "react";
import { useRouter } from "next/navigation";
import { useAuthStore, CURRENT_AUTH_VERSION } from "@/lib/store";

/**
 * Mounted once in the root layout.
 * After Zustand rehydrates, checks two invariants:
 *   1. Stored user must have a role (stale pre-RBAC tokens won't)
 *   2. Stored auth version must match CURRENT_AUTH_VERSION (forces re-login on breaking changes)
 * Either failure wipes local state, clears the server cookie, and redirects home.
 */
export function AuthRoleGuard() {
  const router      = useRouter();
  const user        = useAuthStore((s) => s.user);
  const hydrated    = useAuthStore((s) => s._hasHydrated);
  const authVersion = useAuthStore((s) => s.authVersion);
  const logout      = useAuthStore((s) => s.logout);

  useEffect(() => {
    if (!hydrated) return;
    if (!user) return;
    if (user.role && authVersion === CURRENT_AUTH_VERSION) return;

    // Missing role or version mismatch: wipe session and redirect
    logout().finally(() => {
      router.replace("/");
    });
  }, [hydrated, user, authVersion, logout, router]);

  return null;
}
